import GameCommonDis from "../Description/GameCommonDis";
import { useEffect, useRef } from "react";
import Link from "next/link";
import styles from "../../styles/BreadCrumbs.module.css";


export default function CommenDis(props) {

  const video = useRef(null);
  var videoURL = "";

 function catcheck(value) {
    var myCom;
    //console.log(value);
    if (value!= null) {
      myCom =<li><Link href={props.catlink} passHref>{props.cat}</Link></li>
      
    }

    return myCom;
  }

  function tags_list(value) {
    var tags_list = [];
    var i;
    for (i = 0; i < value.length; i++) {
      tags_list[i] = (
        <span key={i} className="tags">
          {value[i]}
        </span>
      );
    }
    return tags_list;
  }

  function setvideo(value) {
    var videoLink = value;
    if (videoLink.length > 30) {
      video.current.setAttribute("style", "display:flex");
      
    } else {
      // video.current.setAttribute("style", "display:none !important");
     
    }
  }

  useEffect(() => {
    setvideo(props.video);
  }, );

  return (
    <div>
      <div className="dis-container">
       <div className="thumb-dis">
          <div className="dis">
           
<div className={styles.contant2}>
<ol className={`${styles.breadcrumb }`}>
<li><Link href="/" passHref>Playcutegames</Link></li>

{!props.coloring== "coloring"&&<><li><Link href="/all-categories" passHref>Categories</Link></li></>}
{props.coloring == "coloring"&&<><li><Link href="/coloring-page" passHref>Coloring Page</Link></li></>}

{catcheck(props.catlink)}
<li className={styles.current}>{props.gamename}</li>
</ol>
</div>


            <h1 className="contant name">{props.name}</h1>
               {/* Release info (from JSON) */}
                {props.Details!=undefined&& (

<div className="release_info_container">
        {props.Details.Developer!=undefined&& (<div className="release_info_item">
          <div className="release_info_left">Developer:</div>
          <div className="release_info_right">
            <span>{props.Details.Developer}</span>
          </div>
        </div>)} 
        {props.Details.Rating!=undefined&& (<div className="release_info_item">
          <div className="release_info_left">Rating:</div>
          <div className="release_info_right">
            <span>{props.Details.Rating[0]+"/10"}</span>
            <span> ({props.Details.Rating[1]} votes)</span>
          </div>
        </div>)}  
        {props.Details.Released!=undefined&& (<div className="release_info_item">
          <div className="release_info_left">Released:</div>
          <div className="release_info_right">
            <span>{props.Details.Released}</span>
          </div>
        </div>)}  
        {props.Details.LastUpdated!=undefined&& (<div className="release_info_item">
          <div className="release_info_left">Last Updated:</div>
          <div className="release_info_right">
            <span>{props.Details.LastUpdated}</span>
          </div>
        </div>)}  
        {props.Details.Technology!=undefined&& (<div className="release_info_item">
          <div className="release_info_left">Technology:</div>
          <div className="release_info_right">
            <span>{props.Details.Technology}</span>
          </div>
        </div>)}  
        {props.Details.Platform!=undefined&& (<div className="release_info_item">
          <div className="release_info_left">Platform:</div>
          <div className="release_info_right">
            <span>{props.Details.Platform}</span>
          </div>
        </div>)}  
       {props.Details.Wikipages!=undefined&& (
        <div className="release_info_item">
          <div className="release_info_left">Wiki Page:</div>
          <Link href={props.Details.Wikipages.Url} passHref className="release_info_right" target="_blank" rel="noopener noreferrer">{props.Details.Wikipages.Name}</Link>
        </div>
       )} 
      </div>

                )}
      
      <div className="contant tags-list">{tags_list(props.tag)}</div>
          </div>

        </div>
        </div>
      <div className="dis-container">
        <div className="thumb-dis">
          <div className="dis">
            <div className="contant para description"dangerouslySetInnerHTML={{__html:props.dis}}></div>
            {/* FAQ */}
            

            
            {props.faq!=undefined&& (
                 <div className="contant para description">
          <h2 className="H21">❓ Frequently Asked Questions</h2>
          <ol style={{ paddingInlineStart: "30px", color: "var(--Sub_Heading)", fontSize:"20px",  fontWeight:"800"}}>
          {props.faq.map((item, index) => (
              <li key={index}>
                <h3 className="H22">{item.question}</h3>
                <p>{item.answer}</p>
              </li>
            ))} 
            </ol>
            </div>
      )}
            {props.howto!=undefined&&<h2 className="contant name">How to play {props.name} Game</h2>}
            {props.howto!=undefined&&<div className="contant para description"dangerouslySetInnerHTML={{__html:props.howto}}></div>}
            
            
          </div>

          {props.video.length > 30 &&<div ref={video} className="videos">
              <h2 className="contant name">Gameplay Video</h2>
              <iframe
                className="videos_iframe"
                width="560"
                height="315"
                src={props.video+"?rel=0"}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen="allowfullscreen"
              ></iframe>
            </div>}
            
          
        </div>

       
      </div>
       
      <GameCommonDis />
    </div>
  );
}
